module.exports = __webpack_public_path__ + "img/northern ireland.43b61fea.svg";